export enum AuthLevels {
  SUBSCRIBER = 'subscriber',
  PLASTUN = 'plastun',
  PLASTUN_SENIOR = 'plastunsenior',
  VYHOVNYK = 'vyhovnyk',
  AUTOR = 'author',
  ADMIN = 'admin',
}
